<template>
  <div id="userDetails">
    <div class="">
      <ol class="breadcrumb">
        <li><a href="#/dashboard">Dashboard</a></li>
        <li class="active"><a>My Account</a></li>
      </ol>
    </div>
    <div class="content user-box middle">
      <div class="cell">
        <div class="container">
          <p class="sub-title text-center mb0">ACCOUNT SETTINGS</p>

          <form class="form-horizontal mt50">
            <div class="form-group">
              <label class="col-xs-2 control-label">Type of account:</label>
              <div class="col-xs-4">
                <el-select v-model="user.type" class="w100" disabled>
                   <el-option
                      v-bind:key="user.type"
                      class="w100"
                      :value="user.type"
                      :label="mapUserType(user.type)"
                    ></el-option>
                </el-select>
              </div>
              <label class="col-xs-2 control-label">Email:</label>
              <div class="col-xs-4">
                <el-input v-model="user.email" disabled></el-input>
              </div>
            </div>
            <div class="form-group">
              <label class="col-xs-2 control-label">Title:</label>
              <div class="col-xs-4">
                <el-select v-model="user.title" class="w100">
                  <el-option label="Mr" value="Mr"></el-option>
                  <el-option label="Mrs" value="Mrs"></el-option>
                </el-select>
              </div>
              <label class="col-xs-2 control-label">Phone:</label>
              <div class="col-xs-4">
                <el-input v-model="user.phone"></el-input>
              </div>
            </div>
            <div class="form-group">
              <label class="col-xs-2 control-label">First name:</label>
              <div class="col-xs-4">
                <el-input v-model="user.first_name"></el-input>
              </div>
              <label class="col-xs-2 control-label">Password:</label>
              <div class="col-xs-4">
                <el-input v-model="password" show-password></el-input>
              </div>
            </div>
            <div class="form-group">
              <label class="col-xs-2 control-label">Last name:</label>
              <div class="col-xs-4">
                <el-input v-model="user.last_name"></el-input>
              </div>
              <label class="col-xs-2 control-label">Confirm password:</label>
              <div class="col-xs-4">
                <el-input v-model="confirm_password" show-password></el-input>
              </div>
            </div>
            <div class="form-group">
              <label class="col-xs-2 control-label">Country:</label>
              <div class="col-xs-4">
                <div class="el-input el-input--suffix">
                  <country-select
                    className="el-input__inner"
                    :country="user.country"
                    v-model="user.country"
                  />
                  <span class="el-input__suffix">
                    <span class="el-input__suffix-inner">
                      <i
                        class="
                          el-select__caret
                          el-input__icon
                          el-icon-arrow-down
                        "
                      ></i>
                    </span>
                  </span>
                </div>
                <!-- <el-input v-model="user.country"></el-input> -->
              </div>
              <template v-if="user.type == 'distributors'">
                <label class="col-xs-2 control-label">Color:</label>
                <div class="col-xs-4">
                  <color-picker
                    class="mr20 el-color-picker"
                    v-model="user.color"
                    :color="user.color"
                  />
                </div>
              </template>
            </div>
            <div class="form-group">
              <label class="col-xs-2 control-label">City:</label>
              <div class="col-xs-4">
                <el-input v-model="user.city"></el-input>
              </div>
              <template v-if="user.type == 'distributors'">
                <label class="col-xs-2 control-label">Logo:</label>
                <div class="col-xs-4">
                  <el-input
                    type="file"
                    id="file"
                    v-model="user.file_name"
                    @input="handle_file_upload"
                  ></el-input>
                  <span style="color: black; font-size: 12px"
                    >Please upload PNG image 50x350px with transparent
                    background</span
                  >
                  <div
                    style="
                      height: 50px;
                      border: 1px solid #dcdfe6;
                      text-align: center;
                    "
                    class="mt10"
                  >
                    <img
                      style="width: 350px; max-height: 50px"
                      id="preview"
                      ref="preview"
                      :src="thumbnail_url"
                      alt="your image"
                    />
                  </div>
                  <a style="color: black" @click="removeLogo"
                    >Delete current logo</a
                  >
                </div>
              </template>
            </div>
            <div class="form-group">
              <label class="col-xs-2 control-label">Preferred currency:</label>
              <div class="col-xs-4">
                <el-select v-model="user.currency" class="w100">
                  <el-option label="USD" value="USD"></el-option>
                  <el-option label="EUR" value="EUR"></el-option>
                  <el-option label="CNY" value="CNY"></el-option>
                </el-select>
              </div>
              <div class="col-xs-6">
                <el-checkbox v-model="checked" class="black"
                  >Subscribe me Black Nova newsletter.</el-checkbox
                >
              </div>
            </div>
            <div class="form-group mt50">
              <div class="col-xs-2 col-xs-offset-5">
                <el-button class="button1" @click="edit_user()">
                  Confirm and update
                </el-button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>

    <div class="nav-footer white font16">
      <span class="click inlineb">
        <router-link class="white" to="/dashboard">
          <i class="iconfont3 icon-back"></i> BACK</router-link
        ></span
      >
    </div>
  </div>
</template>

<script>
import "@/assets/css/user.css";
import axios from "axios";
import ColorPicker from "../components/ColorPicker.vue";

export default {
  name: "userDetails",
  components: {
    ColorPicker,
  },
  data() {
    return {
      user: {},
      checked: "",
      password: "",
      confirm_password: "",
      thumbnail_url: "",
      file: {},
    };
  },
  methods: {
    removeLogo() {
      var c = confirm("Do you want to remove logo?");
      if (!c) return;
      axios.get("/user/remove-logo/" + this.$route.params.id).then(() => {
        this.file = {};
        this.user.file_name = "";
        this.$refs.preview.setAttribute("src", "");
      });
    },
    handle_file_upload() {
      var _this = this;
      this.file = document.getElementById("file").files[0];
      if (this.file.type != "image/png") {
        alert("Only .png image format!");
        _this.file = {};
        this.user.file_name = "";
        _this.$refs.preview.setAttribute("src", "");
        return false;
      }
      var reader = new FileReader();
      reader.onload = (e) => {
        var image = new Image();
        image.src = e.target.result;
        image.onload = function () {
          var height = this.height;
          var width = this.width;
          if (height > 50 || width > 350) {
            alert("Height and Width must not exceed 50x350px.");
            document.getElementById("file").value = "";
            _this.file = {};
            this.user.file_name = "";
            _this.$refs.preview.setAttribute("src", "");
            return false;
          }
          _this.$refs.preview.setAttribute("src", e.target.result);
        };
      };
      reader.readAsDataURL(this.file); // convert to base64 string
    },
    getData() {
      axios.get("/user/single/" + this.$route.params.id).then((response) => {
        this.thumbnail_url =
          this.$store.state.serverURL +
          "/" +
          response.data.file_name +
          "?" +
          Date.now();
        response.data.file_name = "";
        this.user = response.data;
        this.password = this.user.password;
      }); 
    },
    edit_user() {
      if ((/\s/).test(this.password)) {
          this.$message({
            type: "error",
            message: "No spaces allowed in password",
          });
          return;
        }
      if (
        (this.password == this.user.password && this.confirm_password == "") ||
        this.confirm_password == this.password
      ) {
        this.user.password = this.password;
        let formData = new FormData();
        if (this.file instanceof File) {
          formData.append("file", this.file);
        }
        for (var attr in this.user) {
          formData.append(attr, this.user[attr]);
        }
        axios
          .put("/user/" + this.user._id, formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          })
          .then((res) => {
            if (res.data.ok == 1) {
              this.$message({
                type: "success",
                message: "Edited!",
              });
              axios
                .get("/user/single/" + this.$route.params.id)
                .then((response) => {
                  this.$store.state.user = response.data;
                  this.$router.go(-1);
                }); 
            } else {
              this.$message({
                type: "error",
                message: "Edit Failed!",
              });
            }
          })
          .catch(function (error) {
            alert(error);
          });
      } else {
        this.$message({
          type: "error",
          message: "Edit Failed! Please confirm same password!",
        });
      }
    },
    mapUserType(type) {
      return this.$store.state.userTypeMap[type];
    },
    delete_user(ID, name) {
      const h = this.$createElement;
      this.$msgbox({
        title: "DELETE USER",
        message: h("p", null, [
          h("span", null, "Are you sure you want to delete "),
          h("span", { style: "color: red" }, name + "?"),
        ]),
        showCancelButton: true,
        confirmButtonText: "Yes",
        cancelButtonText: "No",
        beforeClose: (action, instance, done) => {
          if (action === "confirm") {
            axios
              .delete("/user/" + ID)
              .then((res) => {
                if (res.data.ok == 1) {
                  this.$message({
                    type: "success",
                    message: "Deleted!",
                  });

                  this.$router.go(-1);
                } else {
                  this.$message({
                    type: "error",
                    message: "Delete Failed!",
                  });
                }
              })
              .catch(function (error) {
                window.console.log(error);
              });
          } else {
            done();
          }
        },
      });
    },
  },
  mounted() {
    this.getData();
  },

  created: function () {
    this.$parent.headerBg();
    this.$parent.footerB();
  },
  computed: {
    userType: function () {
      return this.$store.state.user.type;
    },
  },
};
</script>
